/* eslint-disable global-require, no-case-declarations */
import { bool, node } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { breakpoints } from 'TMConstants';
import { backgroundVariantOptions } from 'TMPropTypes/commonOptionsProps';

const Options = styled.div`
    position: relative;
    overflow: hidden;

    @media (max-width: ${breakpoints.mobileTablet}px) {
        display: ${({ hideOnMobile }) => hideOnMobile && 'none'};
    }

    @media (min-width: ${breakpoints.mobileTablet}px) {
        display: ${({ hideOnDesktop }) => hideOnDesktop && 'none'};
    }

    background-color: none;

    ${({ backgroundVariant }) =>
        backgroundVariant &&
        `
        background-color: ${backgroundVariant};
    `}
    ${({ noSideMargins }) =>
        noSideMargins &&
        `
        margin-left: -20px;
        margin-right: -20px;
        padding-left: 20px;
        padding-right: 20px;
`}
`;

const SharedOptions = ({
    hideOnMobile,
    hideOnDesktop,
    backgroundVariant = 'none',
    noSideMargins,
    children
}) => {
    return (
        <Options
            hideOnMobile={hideOnMobile}
            hideOnDesktop={hideOnDesktop}
            noSideMargins={noSideMargins}
            backgroundVariant={backgroundVariant}>
            {children}
        </Options>
    );
};

SharedOptions.propTypes = {
    children: node.isRequired,
    hideOnMobile: bool,
    hideOnDesktop: bool,
    backgroundVariant: backgroundVariantOptions,
    noSideMargins: bool
};

export default SharedOptions;
